import * as z from 'zod';
import '@inrev/core';
import 'ts-pattern';
import '../../../enums.mjs';
import '../../currency/currency.mjs';
import '../../financial-formula/adjustable-value.mjs';
import '../../financial-formula/adjustable-values-update.mjs';
import '../../financial-formula/adjustment.mjs';
import '../../financial-formula/formula.mjs';
import '../../../utils/describe-fred-change.util.mjs';
import 'luxon';
import { isoDateSchema } from '../../opaque.mjs';
import '../../../utils/extractable-extension.util.mjs';
import '../../../utils/financial-analysis-metrics.util.mjs';
import { currencySchema, financialStatementFileSchema } from '../../utils.mjs';
import '../../../utils/normalize-us-state.util.mjs';
import './financial-period/balance-sheet-data.mjs';
import './financial-period/financial-period-extraction-webhook.mjs';
import './financial-period/income-statement-data.mjs';
import './financial-period/income-statement-fields.mjs';
import './financial-period/income-statement-with-adjustments.mjs';
import './financial-period/line-item-group.mjs';
import './financial-period/section-keys.mjs';
import './financial-period/statement-metadata.mjs';
import './financial-period/view-shapes.mjs';
import '../../../utils/validate-close-required-fields.util.mjs';
import { validateWipDateRequired } from '../../../utils/validate-financial-statement-required-fields.util.mjs';
import '../../../utils/wip-extraction-readiness.util.mjs';

const baseProfitabilitySchema = z.object({
    profitableYtd: z.boolean().nullish().meta({ partial: true }),
    profitableLastFye: z.boolean().nullish().meta({ partial: true }),
});
const largeProfitabilitySchema = z.object({
    ...baseProfitabilitySchema.shape,
    profitableYearPriorToLastFye: z.boolean().nullish().meta({ partial: true }),
});
const mediumBalanceSheetSchema = z.object({
    corporateCash: currencySchema.nullish().meta({ partial: true }),
    currentAssets: currencySchema.nullish().meta({ partial: true }),
    currentLiabilities: currencySchema.nullish().meta({ partial: true }),
    totalAssets: currencySchema.nullish().meta({ partial: true }),
    totalLiabilities: currencySchema.nullish().meta({ partial: true }),
});
const largeBalanceSheetSchema = z.object({
    ...mediumBalanceSheetSchema.shape,
    accountsPayable: currencySchema.nullish().meta({ partial: true }),
    accountsReceivable: currencySchema.nullish().meta({ partial: true }),
    accruedExpenses: currencySchema.nullish().meta({ partial: true }),
    bankLinePayable: currencySchema.nullish().meta({ partial: true }),
    creditCardsPayable: currencySchema.nullish().meta({ partial: true }),
    currentPortionOfLtd: currencySchema.nullish().meta({ partial: true }),
    overbillings: currencySchema.nullish().meta({ partial: true }),
    termLoanDebt: currencySchema.nullish().meta({ partial: true }),
    underbillings: currencySchema.nullish().meta({ partial: true }),
});
const mediumIncomeStatementSchema = z.object({
    revenue: currencySchema.nullish().meta({ partial: true }),
});
const largeIncomeStatementSchema = z.object({
    ...mediumIncomeStatementSchema.shape,
    gaExpense: currencySchema.nullish().meta({ partial: true }),
});
const largeBankDetailsSchema = z.object({
    blocSize: currencySchema.nullish().meta({ partial: true }),
});
const mediumWorkInProgressStatementSchema = z.object({
    date: isoDateSchema.nullish().meta({ partial: true }),
    projectBacklogCost: currencySchema.nullish().meta({ partial: true }),
});
const largeWorkInProgressStatementSchema = z.object({
    ...mediumWorkInProgressStatementSchema.shape,
    projectBacklogGrossProfit: currencySchema.nullish().meta({ partial: true }),
});
const aiProfitabilitySchema = z.object({
    profitableYtd: z.boolean().nullish().meta({ partial: true }),
});
const aiSmallProfitabilitySchema = z.object({
    profitableYtd: z.boolean().nullish().meta({ partial: true }),
    profitableLastFye: z.boolean().nullish().meta({ partial: true }),
});
const aiMediumFinancialSchema = z.object({
    profitability: aiProfitabilitySchema.nullish(),
    workInProgressStatement: mediumWorkInProgressStatementSchema
        .superRefine(validateWipDateRequired)
        .nullish(),
    files: z.array(financialStatementFileSchema).meta({ partial: true }),
});
const aiLargeFinancialSchema = z.object({
    ...largeBankDetailsSchema.shape,
    profitability: aiProfitabilitySchema.nullish(),
    workInProgressStatement: largeWorkInProgressStatementSchema
        .superRefine(validateWipDateRequired)
        .nullish(),
    files: z.array(financialStatementFileSchema).meta({ partial: true }),
});

export { aiLargeFinancialSchema, aiMediumFinancialSchema, aiProfitabilitySchema, aiSmallProfitabilitySchema, baseProfitabilitySchema, largeBalanceSheetSchema, largeBankDetailsSchema, largeIncomeStatementSchema, largeProfitabilitySchema, largeWorkInProgressStatementSchema, mediumBalanceSheetSchema, mediumIncomeStatementSchema, mediumWorkInProgressStatementSchema };
